import { type FunctionComponent } from 'react';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';

// styles
import styles from './DesignsBreadcrumbs.scss';

export const DesignsBreadcrumbs: FunctionComponent = () => {
    return (
        <div className={styles.container}>
            <Link href={'/'}>
                <FormattedMessage id="designs.designsBradcrumbs.home" defaultMessage="Home" />
            </Link>
            <span className={styles.lastItem}>
                <FormattedMessage id="designs.designsBradcrumbs.designs" defaultMessage="Designs" />
            </span>
        </div>
    );
};
